import Vue from 'vue'

export default {
	create({}, type){
		return Vue.api.post('clinicType/', {
			"name": type.name || '',
			"code": type.code || 0,
			"status": "active"
		})
	},
	update({}, type) {
		return Vue.api.put('clinicType/' + type._id, {
			"name": type.name,
			"code": type.code,
			"status": "active"
		})
	},
	get({}, id) {
		return Vue.api.get('clinicType/' + id)
	},
	list({}, filter) {
		return Vue.api.put('clinicType/list', {
			"per_page": filter.per_page || 5,
			"current_page": filter.current_page || 1,
			"name": filter.name || '',
			"code": filter.code || 0,
			"status": "active"
		})
	},
	all({}, term = '') {
		return Vue.api.get('clinicType/all/get', {term: term})
	}
}



// WEBPACK FOOTER //
// ./src/vuex/services/clinicType/actions.js